import { BadIcon, CorrectIcon } from './Icons';
import classes from './Correction.module.scss';
import clsx from 'clsx';

const Correction = (props) => {
    const { question, blankId } = props;

    const blankTries = question.tries.reduce((acc, tries) => {
        if (!tries[blankId]?.isCorrect) {
            return [...acc, tries[blankId].userAnswer];
        }
    }, []) ?? [];

    return (
        <>
            {blankTries.map((answer, index) => {
                return (
                    <span key={index} className={clsx(classes.pill, classes.removed)} data-type="removed" >
                        <span className={classes.removedicon} data-animate="icon" >
                            <BadIcon />
                        </span>
                        <span>{answer}</span>
                    </span>
                )
            })}

            {question.answer?.[blankId]?.isCorrect &&
                <span className={clsx(classes.pill, classes.added)} >
                    <span>{question.answer[blankId].userAnswer}</span>
                    <span className={classes.addedicon}><CorrectIcon /></span>
                </span>
            }
        </>
    )
}

export default Correction;